import React, { PropsWithChildren } from "react";

export default function LoginModel({ children }: PropsWithChildren) {
  return (
    <>
      <div className="relative flex flex-col my-4 mx-4 p-0 shadow-2xl rounded-2xl md:space-y-0 md:w-[25rem] w-full bg-white bg-opacity-70">
        <div className="flex justify-start flex-col md:mx-[2.5rem] mx-8 mt-[1.875rem] mb-2">
          {children}
        </div>
      </div>
    </>
  );
}
